var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDownArrowIocn = function SvgDownArrowIocn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.23748 4.89928C2.55412 4.58935 3.0675 4.58935 3.38415 4.89928L8.00003 9.41745L12.6158 4.89929C12.9325 4.58935 13.4459 4.58934 13.7625 4.89928C14.0792 5.20922 14.0792 5.71173 13.7625 6.02167L8.57337 11.101C8.42131 11.2499 8.21508 11.3335 8.00003 11.3335C7.78499 11.3335 7.57876 11.2499 7.4267 11.101L2.23748 6.02168C1.92084 5.71174 1.92084 5.20922 2.23748 4.89928Z",
    fill: "white",
    fillOpacity: 0.96
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDownArrowIocn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "down-arrow-iocn.204e10446bfdddd690ab588b9a98bd3d.svg";